module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "cms-edit"
  }, [(_vm.loading) ? _c('div', {
    staticClass: "cc-loader"
  }, [_c('div', {
    staticClass: "spinner"
  })]) : _c('div', [(!_vm.fetchError) ? _c('div', [_c('div', {
    staticClass: "top-page"
  }, [_c('div', {
    staticClass: "cc-inside"
  }, [_c('div', {
    staticClass: "columns"
  }, [_c('h1', [(_vm.$route.params.id) ? _c('span', [_vm._v("\n                                Edit\n                            ")]) : _c('span', [_vm._v("\n                                Create\n                            ")]), _vm._v("\n                            CMS page "), (_vm.page.title) ? _c('span', [_vm._v(": \"" + _vm._s(_vm._f("truncate")(_vm.page.title, 50)) + "\"")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "cc-w-auto cc-right"
  }, [_c('router-link', {
    staticClass: "btn cc-bg-green fa-angle-left",
    attrs: {
      "to": {
        name: 'cms'
      }
    }
  }, [_vm._v("Back to CMS pages")])], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "cc-inside"
  }, [_c('form', {
    staticClass: "form-large",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.submitForm($event)
      }
    }
  }, [_c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "cc-12 cc-9-l"
  }, [_c('div', {
    staticClass: "boxed"
  }, [_c('h3', [_vm._v("Page content")]), _vm._v(" "), _c('div', {
    staticClass: "form-item",
    class: {
      'error': _vm.$v.page.title.$error
    }
  }, [_c('label', {
    staticClass: "block"
  }, [_vm._v("\n                                        Title\n\n                                        "), _c('div', {
    staticClass: "pull-right form-checkbox"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.autoSlug),
      expression: "autoSlug"
    }],
    attrs: {
      "type": "checkbox",
      "name": "autoSlug"
    },
    domProps: {
      "checked": Array.isArray(_vm.autoSlug) ? _vm._i(_vm.autoSlug, null) > -1 : (_vm.autoSlug)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.autoSlug,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.autoSlug = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.autoSlug = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.autoSlug = $$c
        }
      }
    }
  }), _vm._v("\n                                                Auto-fill slug ?\n                                            ")])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.page.title),
      expression: "page.title",
      modifiers: {
        "trim": true
      }
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.page.title)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.page.title = $event.target.value.trim()
      }, function($event) {
        _vm.$v.page.title.$touch(), _vm.slugify()
      }],
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), (!_vm.$v.page.title.maxLength) ? _c('span', {
    staticClass: "warning"
  }, [_vm._v("\n                                        Can not be longer than " + _vm._s(_vm.$v.page.title.$params.maxLength.max) + " letters.\n                                    ")]) : _vm._e(), _vm._v(" "), (!_vm.$v.page.title.required) ? _c('span', {
    staticClass: "warning"
  }, [_vm._v("\n                                        Field is required\n                                    ")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-item",
    class: {
      'error': _vm.$v.page.content.$error
    }
  }, [_c('label', {
    staticClass: "block"
  }, [_vm._v("\n                                        Body\n                                    ")]), _vm._v(" "), _c('tinymce', {
    attrs: {
      "textareaId": "text1",
      "content": _vm.page.content
    },
    on: {
      "input": function($event) {
        _vm.$v.page.content.$touch()
      }
    },
    model: {
      value: (_vm.page.content),
      callback: function($$v) {
        _vm.page.content = $$v
      },
      expression: "page.content"
    }
  }), _vm._v(" "), (!_vm.$v.page.content.required) ? _c('span', {
    staticClass: "warning"
  }, [_vm._v("\n                                        Field is required\n                                    ")]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "form-item",
    class: {
      'error': _vm.$v.page.content2.$error
    }
  }, [_c('label', {
    staticClass: "block"
  }, [_vm._v("\n                                        Body 2\n                                    ")]), _vm._v(" "), _c('tinymce', {
    attrs: {
      "textareaId": "text2",
      "content": _vm.page.content2
    },
    on: {
      "input": function($event) {
        _vm.$v.page.content2.$touch()
      }
    },
    model: {
      value: (_vm.page.content2),
      callback: function($$v) {
        _vm.page.content2 = $$v
      },
      expression: "page.content2"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-item"
  }, [_c('label', {
    staticClass: "block cc-mab-10"
  }, [_vm._v("\n                                        Images\n                                        "), _c('span', {
    staticClass: "pull-right badge cc-bg-red"
  }, [_vm._v("\n                                            (" + _vm._s(_vm.dzOptions.maxFiles) + " files max - " + _vm._s(_vm.dzOptions.maxFilesize) + "Mo max. / file)\n                                        ")]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })]), _vm._v(" "), _c('dropzone', {
    attrs: {
      "id": 'dropzone1',
      "url": _vm.dzOptions.url,
      "dz-options": _vm.dzOptions,
      "dz-medias": _vm.page.media
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "cc-12 cc-3-l"
  }, [_c('div', {
    staticClass: "boxed"
  }, [_c('h3', [_vm._v("Page settings")]), _vm._v(" "), _c('div', {
    staticClass: "form-item",
    class: {
      'error': _vm.$v.page.lang.$error
    }
  }, [_c('label', {
    staticClass: "block"
  }, [_vm._v("Language")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.page.lang),
      expression: "page.lang",
      modifiers: {
        "trim": true
      }
    }],
    attrs: {
      "name": "lang"
    },
    on: {
      "input": function($event) {
        _vm.$v.page.lang.$touch()
      },
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.page.lang = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "fr"
    }
  }, [_vm._v("fr")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "en"
    }
  }, [_vm._v("en")])]), _vm._v(" "), (!_vm.$v.page.lang.required) ? _c('span', {
    staticClass: "warning"
  }, [_vm._v("\n                                        Field is required\n                                    ")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-item",
    class: {
      'error': _vm.$v.page.dateCreated.$error
    }
  }, [_c('label', {
    staticClass: "block"
  }, [_vm._v("Created date")]), _vm._v(" "), _c('Flatpickr', {
    attrs: {
      "options": _vm.fpOptions
    },
    on: {
      "input": function($event) {
        _vm.$v.page.dateCreated.$touch()
      }
    },
    model: {
      value: (_vm.page.dateCreated),
      callback: function($$v) {
        _vm.page.dateCreated = (typeof $$v === 'string' ? $$v.trim() : $$v)
      },
      expression: "page.dateCreated"
    }
  }), _vm._v(" "), (!_vm.$v.page.dateCreated.required) ? _c('span', {
    staticClass: "warning"
  }, [_vm._v("\n                                        Field is required\n                                    ")]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "form-item",
    class: {
      'error': _vm.$v.page.published.$error
    }
  }, [_c('label', {
    staticClass: "block"
  }, [_vm._v("Status")]), _vm._v(" "), _c('div', {
    staticClass: "form-radio"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.page.published),
      expression: "page.published",
      modifiers: {
        "trim": true
      }
    }],
    attrs: {
      "type": "radio",
      "name": "published",
      "value": "true"
    },
    domProps: {
      "checked": _vm._q(_vm.page.published, "true")
    },
    on: {
      "__c": function($event) {
        _vm.page.published = "true"
      }
    }
  }), _vm._v("\n                                            Published\n                                        ")]), _vm._v(" "), _c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.page.published),
      expression: "page.published",
      modifiers: {
        "trim": true
      }
    }],
    attrs: {
      "type": "radio",
      "name": "published",
      "value": "false"
    },
    domProps: {
      "checked": _vm._q(_vm.page.published, "false")
    },
    on: {
      "__c": function($event) {
        _vm.page.published = "false"
      }
    }
  }), _vm._v("\n                                            Pending\n                                        ")])]), _vm._v(" "), (!_vm.$v.page.published.required) ? _c('span', {
    staticClass: "warning"
  }, [_vm._v("\n                                        Field is required\n                                    ")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "boxed"
  }, [_c('h3', [_vm._v("SEO")]), _vm._v(" "), _c('div', {
    staticClass: "form-item",
    class: {
      'error': _vm.$v.page.slug.$error
    }
  }, [_c('label', {
    staticClass: "block"
  }, [_vm._v("Url rewriting")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.page.slug),
      expression: "page.slug",
      modifiers: {
        "trim": true
      }
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.page.slug)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.page.slug = $event.target.value.trim()
      }, function($event) {
        _vm.$v.page.slug.$touch()
      }],
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), (!_vm.$v.page.slug.required) ? _c('span', {
    staticClass: "warning"
  }, [_vm._v("\n                                        Field is required\n                                    ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "message message-info fa-info-circle"
  }, [_c('em', [_vm._v("Apparaît après l'adresse du site.")]), _c('br'), _c('br'), _vm._v(" "), _c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.fullUrl)
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-item",
    class: {
      'error': _vm.$v.page.metatitle.$error
    }
  }, [_c('label', {
    staticClass: "block"
  }, [_vm._v("Meta title (" + _vm._s(_vm.$v.page.metatitle.$params.minLength.min) + "-" + _vm._s(_vm.$v.page.metatitle.$params.maxLength.max) + " caract.)")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.page.metatitle),
      expression: "page.metatitle",
      modifiers: {
        "trim": true
      }
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.page.metatitle)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.page.metatitle = $event.target.value.trim()
      }, function($event) {
        _vm.$v.page.metatitle.$touch()
      }],
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), (!_vm.$v.page.metatitle.required) ? _c('span', {
    staticClass: "warning"
  }, [_vm._v("\n                                        Field is required\n                                    ")]) : _vm._e(), _vm._v(" "), (!_vm.$v.page.metatitle.maxLength) ? _c('span', {
    staticClass: "warning"
  }, [_vm._v("\n                                        Can not be longer than " + _vm._s(_vm.$v.page.metatitle.$params.maxLength.max) + " letters.\n                                    ")]) : _vm._e(), _vm._v(" "), (!_vm.$v.page.metatitle.minLength) ? _c('span', {
    staticClass: "warning"
  }, [_vm._v("\n                                        Can not be shorter than " + _vm._s(_vm.$v.page.metatitle.$params.minLength.min) + " letters.\n                                    ")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-item",
    class: {
      'error': _vm.$v.page.metadescription.$error
    }
  }, [_c('label', {
    staticClass: "block"
  }, [_vm._v("Meta description (" + _vm._s(_vm.$v.page.metadescription.$params.minLength.min) + "-" + _vm._s(_vm.$v.page.metadescription.$params.maxLength.max) + " caract.)")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.page.metadescription),
      expression: "page.metadescription",
      modifiers: {
        "trim": true
      }
    }],
    domProps: {
      "value": (_vm.page.metadescription)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.page.metadescription = $event.target.value.trim()
      }, function($event) {
        _vm.$v.page.metadescription.$touch()
      }],
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), (!_vm.$v.page.metadescription.required) ? _c('span', {
    staticClass: "warning"
  }, [_vm._v("\n                                        Field is required\n                                    ")]) : _vm._e(), _vm._v(" "), (!_vm.$v.page.metadescription.maxLength) ? _c('span', {
    staticClass: "warning"
  }, [_vm._v("\n                                        Can not be longer than " + _vm._s(_vm.$v.page.metadescription.$params.maxLength.max) + " letters.\n                                    ")]) : _vm._e(), _vm._v(" "), (!_vm.$v.page.metadescription.minLength) ? _c('span', {
    staticClass: "warning"
  }, [_vm._v("\n                                        Can not be shorter than " + _vm._s(_vm.$v.page.metadescription.$params.minLength.min) + " letters.\n                                    ")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-item",
    class: {
      'error': _vm.$v.page.metakeywords.$error
    }
  }, [_c('label', {
    staticClass: "block"
  }, [_vm._v("Meta keywords (spaced with comas)")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.page.metakeywords),
      expression: "page.metakeywords",
      modifiers: {
        "trim": true
      }
    }],
    domProps: {
      "value": (_vm.page.metakeywords)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.page.metakeywords = $event.target.value.trim()
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })])])]), _vm._v(" "), (_vm.$v.page.$error) ? _c('div', {
    staticClass: "cc-12"
  }, [_c('div', {
    staticClass: "boxed"
  }, [_c('p', [_c('strong', [_vm._v("Please check the following fields before saving the page :")])]), _vm._v(" "), _c('p', {
    staticClass: "cc-pat-10"
  }, [_c('span', {
    class: [_vm.$v.page.title.$error ? 'cc-bg-red' : 'cc-bg-green', 'badge']
  }, [_c('i', {
    class: [_vm.$v.page.title.$error ? 'fa-times' : 'fa-check']
  }), _vm._v(" Page Title\n                                    ")]), _vm._v(" "), _c('span', {
    class: [_vm.$v.page.content.$error ? 'cc-bg-red' : 'cc-bg-green', 'badge']
  }, [_c('i', {
    class: [_vm.$v.page.content.$error ? 'fa-times' : 'fa-check']
  }), _vm._v(" Body\n                                    ")]), _vm._v(" "), _c('span', {
    class: [_vm.$v.page.lang.$error ? 'cc-bg-red' : 'cc-bg-green', 'badge']
  }, [_c('i', {
    class: [_vm.$v.page.lang.$error ? 'fa-times' : 'fa-check']
  }), _vm._v(" Lang\n                                    ")]), _vm._v(" "), _c('span', {
    class: [_vm.$v.page.slug.$error ? 'cc-bg-red' : 'cc-bg-green', 'badge']
  }, [_c('i', {
    class: [_vm.$v.page.slug.$error ? 'fa-times' : 'fa-check']
  }), _vm._v(" Slug\n                                    ")])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "cc-12"
  }, [_c('div', {
    staticClass: "boxed columns"
  }, [_c('div', [_c('button', {
    ref: "submitButton",
    staticClass: "fa-save cc-bg-primary",
    class: [_vm.$v.page.$error ? 'cc-disabled' : ''],
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Save")])]), _vm._v(" "), _c('div', {
    staticClass: "cc-w-auto cc-right"
  }, [_c('a', {
    staticClass: "btn fa-times cc-bg-red",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.modalDelete = true
      }
    }
  }, [_vm._v("Delete this page")])])])])])]), _vm._v(" "), _c('div', {
    class: [{
      'active': _vm.modalSuccess
    }, 'modal']
  }, [_c('button', {
    staticClass: "modal-close",
    on: {
      "click": function($event) {
        _vm.modalSuccess = false
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "modal-overlay",
    on: {
      "click": function($event) {
        _vm.modalSuccess = false
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_vm._v("\n                            Success\n                        ")]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "alert alert-success fa-thumbs-up"
  }, [_vm._v("\n                                Page saved with success\n                            ")])])])]), _vm._v(" "), _c('div', {
    class: [{
      'active': _vm.modalDelete
    }, 'modal']
  }, [_c('button', {
    staticClass: "modal-close",
    on: {
      "click": function($event) {
        _vm.modalDelete = false
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "modal-overlay"
  }), _vm._v(" "), _c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_vm._v("\n                            Confirm action\n                        ")]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "alert alert-info"
  }, [_vm._v("\n                                Do you really want to delete this page ?\n                            ")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    ref: "btnDelete",
    staticClass: "cc-bg-red fa-check",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.deleteData($event)
      }
    }
  }, [_vm._v("CONFIRM DELETE")])])])])])]) : _c('div', [_c('div', {
    staticClass: "top-page"
  }, [_c('div', {
    staticClass: "cc-inside"
  }, [_c('div', {
    staticClass: "columns"
  }, [_c('h1', [_vm._v("\n                            Error for editing CMS page #" + _vm._s(_vm.$route.params.id) + "\n                        ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "cc-inside"
  }, [_c('div', {
    staticClass: "alert alert-error"
  }, [_vm._v("\n                    " + _vm._s(_vm.fetchError) + "\n                ")])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-8d97dff6!./~/vue-loader/lib/selector.js?type=template&index=0!./src/js/views/pages/cms/cms-edit.vue
// module id = 233
// module chunks = 0